// removed by extract-text-webpack-plugin
module.exports = {"notification":"EEAetjH","text":"_3OOTF2t","hasBackground":"_2jSFszG","hasIcon":"_1YG5Vyj","success":"_10Z5DXC","error":"_3GU5ymQ","promotion":"_1xX3I5f","alert":"_1qhdF5P"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Notification/index.css
// module id = ./template/components/Notification/index.css
// module chunks = client.sitechrome